import React from "react";
import "./App.css";
import Routings from "./Routings";
import { BrowserRouter } from "react-router-dom";

function App() {
  return (
    <>
      <BrowserRouter>
        <Routings />
      </BrowserRouter>
    </>
  );
}

export default App;
